import React from "react";

// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "components/ui";
import dayjs from "dayjs";
import {  MuiTypography, ReadMore, SmartImage } from "components/atoms";
import { firstCharacterName } from "utils/firstCharacterName";
import { Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";


function ModalReview({ row }) {
  //const dispatch = useDispatch();
  //   const { id } = useParams();

  //   useEffect(() => {
  //     dispatch(GetReviewsAction({ id }));
  //   }, [id]);
  //   const { reviews } = useSelector((state) => state.reviews);
  console.log(row);
  return (
    <Card className="min-w-full">
      <CardHeader>
        <CardTitle>Review Detail</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-3">
        <div className="flex justify-center w-full items-center">
          <div className="shrink-0 size-24">
            <SmartImage
              src={row.original.image_url}
              alt="User"
              className="img-cover w-24 h-24 rounded-full"
              fallback={
                <div className="size-24 bg-[#d3e6ff] rounded-full flex justify-center items-center">
                  <span className="text-[#2563eb] text-[32px]">
                    {firstCharacterName(
                      row.original.first_name,
                      row.original.last_name
                    )}
                  </span>
                </div>
              }
            />
          </div>
        </div>
        <Table className="text-left text-sm text-muted-foreground">
          <TableBody>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Name
              </TableCell>
              <TableCell className="py-4 text-foreground ">
                <div className="flex justify-end">{row.original.first_name} {row.original.last_name}</div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Rating
              </TableCell>
              <TableCell className="py-4 text-foreground ">
                <div className="flex justify-end">
              <Rating
                name="size-medium"
                readOnly
                value={Number(row.original.star).toFixed(1)}
                precision={0.1}
                size="medium"
                emptyIcon={<StarIcon fontSize="inherit" />}
                sx={{
                  "& .MuiRating-icon": {
                    mx: "1px",
                  },
                  "& .MuiRating-iconEmpty": {
                    mx: "1px",
                  },
                }}
              />

              <MuiTypography
                variant="16"
                color={"text.white"}
                lineHeight={"24px"}
              >
                ({Number(row?.original.star).toFixed(1)})
              </MuiTypography>
           </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Description
              </TableCell>
              <TableCell className="py-4 text-foreground w-[50%]">
                <div className="flex justify-end break-all"><ReadMore comment={row.original.description ?? "N/A"} maxChar={50}/></div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Created At
              </TableCell>
              <TableCell className="py-4 text-foreground ">
                <div className="flex justify-end">
                  {dayjs(Number(row.original.created_at)).format(
                    "DD/MM/YYYY hh:mm A"
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export default ModalReview;
